const About = () => {
  const stats = [
    { number: '15+', label: 'Years Experience' },
    { number: '50+', label: 'Projects Completed' },
    { number: '$2B+', label: 'Investment Facilitated' },
    { number: '25+', label: 'Government Partnerships' }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Leading African Rural Investment Since 2008
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              TS Dotyeni International stands at the forefront of African rural development, bridging the gap between untapped potential and strategic investment. Our deep understanding of rural markets, combined with strong government relationships, positions us uniquely to deliver transformative projects.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              We believe that Africa's economic future lies in its rural spaces. Through careful research, strategic partnerships, and sustainable development practices, we're creating opportunities that benefit investors while empowering local communities.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-emerald-600 mb-2">{stat.number}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/e712de2fad532237c1c689aab94ba2db.jpg"
              alt="TS Dotyeni International team"
              className="rounded-2xl shadow-2xl object-cover w-full h-[500px]"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-emerald-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Award Winning</div>
                  <div className="text-sm text-gray-600">Excellence in Rural Development</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;